/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-underscore-dangle */
import { uriConstants } from '../constants'
import { baseService } from './service'

function _sessionToken(reqObj) {
  const { sessionToken } = JSON.parse(sessionStorage.getItem('signSession'))
    .data.resultObject
  return {
    ...reqObj,
    sessionToken,
  }
}

function _authToken() {
  return JSON.parse(sessionStorage.getItem('signSession')).authToken
}

export function getMemberDetails(data) {
  const url = `${uriConstants.GET_MEMBER_DETAIL_API}?memberUuid=${data.memberUuid}`
  // let reqObj = _sessionToken(data);
  // const dataJson = JSON.stringify(data);
  return baseService.get(url, _authToken())
}

export function findMember(data) {
  const url = `${uriConstants.FIND_MEMBER_API}?memberId=${data.memberId}`
  // let reqObj = _sessionToken(data);
  // const dataJson = JSON.stringify(reqObj);
  return baseService.get(url, _authToken())
  // return baseService.post(url, dataJson);
}

export function getSpecialtyList(data) {
  const url = `${uriConstants.GET_SPECIALTY_LIST_API}?isProvider=true${
    data.memberUuid ? `&${data.memberUuid}` : ''
  }`
  // let reqObj = _sessionToken(data);
  // const dataJson = JSON.stringify(data);
  return baseService.get(url, _authToken())
}

export function getAreaOfFocus(data) {
  const url = uriConstants.GET_AREA_OF_FOCUS_API
  const dataJson = JSON.stringify(data)
  return baseService.post(url, dataJson)
}

export function getLocation(data) {
  const url = uriConstants.GET_LOCATION_API
  // let reqObj = _sessionToken(data);
  const dataJson = JSON.stringify(data)
  return baseService.post(url, dataJson)
}

export function findProviders(data) {
  const url = `${uriConstants.FIND_PROVIDERS_API}?${data}`
  // let reqObj = _sessionToken(data);
  // const dataJson = JSON.stringify(data);
  return baseService.get(url, _authToken())
}

export async function getManagementReferralList({ tins }) {
  return baseService.get(
    uriConstants.GET_MANAGEMENT_REFERRAL_LIST_API,
    _authToken(),
    {
      timestamp: new Date().getTime(),
      checkTooBig: true,
      tins: tins.join(),
      paginate: true,
      tooBigSizeMB: 3,
      pageSize: 1000,
    }
  )
}

export async function readReferralListS3({
  fileKey,
  chunkSize = 1024 * 1024,
  startRange = 0,
}) {
  return baseService.get(uriConstants.GET_S3_SELECT, _authToken(), {
    folderPrefix: 'providerRouteTemp',
    fileKey,
    chunkSize,
    startRange,
  })
}

export async function getpracticeReportList(data) {
  const tinMembersUrl = `${uriConstants.GET_MEMBERS_BY_TIN_API}?tins=${data.value}`
  const assignedMembersUrl = uriConstants.GET_ASSIGNED_MEMBERS_API

  const tinMembersResult = await baseService.get(tinMembersUrl, _authToken())

  if (tinMembersResult.status !== 200) {
    return tinMembersResult
  }

  const members = tinMembersResult.data
  const practiceReportList = []
  let memberTaskList = []

  for (let i = 0; i < members.length; i++) {
    memberTaskList.push(members[i])

    if (memberTaskList.length === 500 || i === members.length - 1) {
      const response = await baseService.post(
        assignedMembersUrl,
        { members: memberTaskList },
        _authToken()
      )

      if (response.status === 200) {
        practiceReportList.push(response.data.assignedMembers)
      }

      memberTaskList = []
    }
  }

  return {
    status: 200,
    data: {
      assignedMembers: practiceReportList.flat(),
    },
  }
}

export function getExtendReferralRequest(data) {
  const url = uriConstants.EXTEND_REFERRAL_API
  // let reqObj = _sessionToken(data);
  const dataJson = JSON.stringify(data)
  return baseService.post(url, dataJson, _authToken())
}

export function getSubmitReferralProvider(data) {
  const url = uriConstants.SUBMIT_REFERRAL_PROVIDER_API
  // let reqObj = _sessionToken(data);
  const dataJson = JSON.stringify(data)
  return baseService.post(url, dataJson, _authToken())
}

export function getProviderDetailsRequest(data) {
  const url = `${uriConstants.GET_PROVIDER_DETAIL}?npi=${
    data.npi
  }&key=${encodeURIComponent(data.key)}`
  // let reqObj = _sessionToken(data);
  // const dataJson = JSON.stringify(data);
  return baseService.get(url, _authToken())
}

export function getSignInUserRequest(data) {
  const url = uriConstants.GET_SIGN_IN_USER
  const dataJson = JSON.stringify(data)
  return baseService.post(url, dataJson)
}

export function ssoLogin(data) {
  const url = uriConstants.SSO_LOGIN
  const dataJson = JSON.stringify(data)
  return baseService.post(url, dataJson)
}

export function getPlanDetailRequest(data) {
  const url = `${uriConstants.GET_PLAN_DETAIL}?memberUuid=${data.memberUuid}`
  // let reqObj = _sessionToken(data);
  // const dataJson = JSON.stringify(data);
  return baseService.get(url, _authToken())
}

export function getForgetPasswordRequest(data) {
  const url = uriConstants.FORGET_PASSWORD
  const dataJson = JSON.stringify(data)
  return baseService.post(url, dataJson)
}

export function getAccessCodeRequest(data) {
  const url = uriConstants.SEND_ACCESS_CODE
  const dataJson = JSON.stringify(data)
  return baseService.post(url, dataJson)
}

export function getMedicalNeighborhood(tin) {
  const url = `${uriConstants.GET_MEDICAL_NEIGHBORHOOD}?tin=${tin}`
  return baseService.get(url, _authToken())
}

export function getUser(authToken) {
  const url = uriConstants.GET_USER
  return baseService.get(url, authToken)
}

export function getGMAPKey() {
  const url = uriConstants.GET_GMAP_KEY
  return baseService.get(url, _authToken())
}

export const getClientList = async () => {
  const url = uriConstants.GET_CLIENT_LIST
  return baseService.get(url, _authToken())
}

export function getReferralMember(data) {
  const url = uriConstants.GET_REFERRAL_MEMBER_API
  return baseService.get(url, _authToken(), {
    memberUuid: data,
  })
}
